
import { Client } from 'ah-api-gateways';
import { Component, Vue, Prop } from 'vue-property-decorator';
import ClientAssigneeInfo from './ClientAssigneeInfo.vue';
import ClientFeeInfo from './ClientFeeInfo.vue';
import ClientMarkupInfo from './ClientMarkupInfo.vue';

@Component({
  components: {
    ClientAssigneeInfo,
    ClientMarkupInfo,
    ClientFeeInfo,
  },
})
export default class ClientRowInfo extends Vue {
  @Prop({ required: true }) client!: Client;
}
